var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjDivider", [
        _vm._v(_vm._s(_vm.$t("AccountManagement.dashboard.Onboarding"))),
      ]),
      _c(
        "div",
        {
          staticStyle: {
            width: "100%",
            height: "270px",
            display: "flex",
            "justify-content": "space-around",
            "text-align": "center",
          },
        },
        [
          _c("div", { staticStyle: { width: "24%", height: "220px" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  width: "100%",
                  height: "70%",
                  "line-height": "180px",
                  "font-size": "88px",
                },
              },
              [_vm._v(_vm._s(_vm.onboardingData.totalCustomer))]
            ),
            _c("span", { staticStyle: { "font-size": "20px" } }, [
              _vm._v(_vm._s(_vm.$t("AccountManagement.dashboard.Total"))),
            ]),
          ]),
          _c("div", { staticStyle: { width: "14%", height: "220px" } }, [
            _c("div", { staticStyle: { height: "48%" } }, [
              _c(
                "div",
                {
                  staticStyle: {
                    "line-height": "100px",
                    "font-size": "40px",
                    height: "80%",
                  },
                },
                [_vm._v(_vm._s(_vm.onboardingData.unfinishedTotal))]
              ),
              _c("span", [
                _vm._v(_vm._s(_vm.$t("AccountManagement.dashboard.Pending"))),
              ]),
            ]),
            _c("div", { staticStyle: { height: "48%" } }, [
              _c(
                "div",
                {
                  staticStyle: {
                    "line-height": "100px",
                    "font-size": "40px",
                    height: "80%",
                  },
                },
                [_vm._v(_vm._s(_vm.onboardingData.finishedTotal))]
              ),
              _c("span", [
                _vm._v(_vm._s(_vm.$t("AccountManagement.dashboard.Initial"))),
              ]),
            ]),
          ]),
          _c(
            "div",
            {
              staticStyle: {
                width: "60%",
                height: "200px",
                display: "flex",
                "justify-content": "space-around",
                "align-items": "flex-end",
              },
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    width: "100px",
                    height: "100px",
                    "font-size": "x-large",
                  },
                },
                [
                  _c("el-progress", {
                    attrs: {
                      type: "circle",
                      percentage: Math.trunc(
                        (_vm.onboardingData.skuTotal /
                          _vm.onboardingData.finishedTotal) *
                          100
                      ),
                      format: _vm.format1,
                      width: 100,
                      "stroke-width": 15,
                    },
                  }),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("AccountManagement.dashboard.SKU"))),
                  ]),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    width: "100px",
                    height: "100px",
                    "font-size": "x-large",
                  },
                },
                [
                  _c("el-progress", {
                    attrs: {
                      type: "circle",
                      percentage: Math.trunc(
                        (_vm.onboardingData.storeTotal /
                          _vm.onboardingData.finishedTotal) *
                          100
                      ),
                      format: _vm.format2,
                      width: 100,
                      "stroke-width": 15,
                    },
                  }),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("AccountManagement.dashboard.Store"))),
                  ]),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    width: "100px",
                    height: "100px",
                    "font-size": "x-large",
                  },
                },
                [
                  _c("el-progress", {
                    attrs: {
                      type: "circle",
                      percentage: Math.trunc(
                        (_vm.onboardingData.poTotal /
                          _vm.onboardingData.finishedTotal) *
                          100
                      ),
                      format: _vm.format3,
                      width: 100,
                      "stroke-width": 15,
                    },
                  }),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("AccountManagement.dashboard.PO"))),
                  ]),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    width: "100px",
                    height: "100px",
                    "font-size": "x-large",
                  },
                },
                [
                  _c("el-progress", {
                    attrs: {
                      type: "circle",
                      percentage: Math.trunc(
                        (_vm.onboardingData.orderTotal /
                          _vm.onboardingData.finishedTotal) *
                          100
                      ),
                      format: _vm.format4,
                      width: 100,
                      "stroke-width": 15,
                    },
                  }),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("AccountManagement.dashboard.Order"))),
                  ]),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _c(
        "BjDivider",
        [
          _vm._v(_vm._s(_vm.$t("AccountManagement.dashboard.Tracker")) + " "),
          _c(
            "template",
            { slot: "right" },
            [
              _c("BjSelectLov", {
                attrs: {
                  multiple: "",
                  "option-list": _vm.onboardingCusList,
                  placeholder: _vm.$t("AccountManagement.dashboard.Customer"),
                },
                on: { change: _vm.chooseCus },
                model: {
                  value: _vm.onboardingCusSelected,
                  callback: function ($$v) {
                    _vm.onboardingCusSelected = $$v
                  },
                  expression: "onboardingCusSelected",
                },
              }),
            ],
            1
          ),
        ],
        2
      ),
      _vm._l(_vm.panelDataList, function (item, index) {
        return _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.panelDataList.length > 0,
                expression: "panelDataList.length > 0",
              },
            ],
            key: index,
            staticClass: "panelBig",
            staticStyle: { width: "100%" },
          },
          [
            _c(
              "div",
              {
                staticClass: "panel",
                staticStyle: { width: "100%", "margin-bottom": "10px" },
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      width: "99%",
                      height: "20px",
                      "margin-left": "1%",
                      "margin-bottom": "10px",
                    },
                  },
                  [
                    item.isShow
                      ? _c("i", { staticClass: "el-icon-caret-bottom" })
                      : _c("i", { staticClass: "el-icon-caret-right" }),
                    _c(
                      "span",
                      {
                        staticStyle: { cursor: "pointer" },
                        on: {
                          click: function ($event) {
                            item.isShow = !item.isShow
                          },
                        },
                      },
                      [_vm._v(_vm._s(item.name))]
                    ),
                  ]
                ),
                item.isShow
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          width: "100%",
                          height: "180px",
                          display: "flex",
                          "justify-content": "space-around",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              width: "22%",
                              height: "180px",
                              border: "2px solid #EBEEF5",
                              padding: "10px 20px",
                              display: "flex",
                              "justify-content": "space-around",
                              "flex-direction": "column",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { "font-size": "larger" } },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("AccountManagement.dashboard.SKUi")
                                  )
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    attrs: {
                                      disabled: "",
                                      "true-label": 1,
                                      "false-label": 0,
                                    },
                                    model: {
                                      value: item.skuFirst,
                                      callback: function ($$v) {
                                        _vm.$set(item, "skuFirst", $$v)
                                      },
                                      expression: "item.skuFirst",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "AccountManagement.dashboard.SKUFirst"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "AccountManagement.dashboard.SKUCurrent"
                                  )
                                ) +
                                  " : " +
                                  _vm._s(item.skuCurrentNum || 0)
                              ),
                            ]),
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "AccountManagement.dashboard.SKUEstimated"
                                  )
                                ) +
                                  " : " +
                                  _vm._s(item.skuEstimateNum || 0)
                              ),
                            ]),
                            _c(
                              "div",
                              { staticStyle: { "text-align": "right" } },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onComplete1(item, "sku")
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "AccountManagement.dashboard.Complete"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              width: "22%",
                              height: "180px",
                              border: "2px solid #EBEEF5",
                              padding: "10px 20px",
                              display: "flex",
                              "justify-content": "space-around",
                              "flex-direction": "column",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { "font-size": "larger" } },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("AccountManagement.dashboard.Storei")
                                  )
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    attrs: {
                                      disabled: "",
                                      "true-label": 1,
                                      "false-label": 0,
                                    },
                                    model: {
                                      value: item.storeFirst,
                                      callback: function ($$v) {
                                        _vm.$set(item, "storeFirst", $$v)
                                      },
                                      expression: "item.storeFirst",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "AccountManagement.dashboard.StoreFirst"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    attrs: {
                                      disabled: "",
                                      "true-label": 1,
                                      "false-label": 0,
                                    },
                                    model: {
                                      value: item.storeApiTest,
                                      callback: function ($$v) {
                                        _vm.$set(item, "storeApiTest", $$v)
                                      },
                                      expression: "item.storeApiTest",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "AccountManagement.dashboard.StoreAPI"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c("div", {
                              staticStyle: { width: "100%", height: "20px" },
                            }),
                            _c(
                              "div",
                              { staticStyle: { "text-align": "right" } },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onComplete2(item, "store")
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "AccountManagement.dashboard.Complete"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              width: "22%",
                              height: "180px",
                              border: "2px solid #EBEEF5",
                              padding: "10px 20px",
                              display: "flex",
                              "justify-content": "space-around",
                              "flex-direction": "column",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { "font-size": "larger" } },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("AccountManagement.dashboard.POi")
                                  )
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    attrs: {
                                      disabled: "",
                                      "true-label": 1,
                                      "false-label": 0,
                                    },
                                    model: {
                                      value: item.poFirst,
                                      callback: function ($$v) {
                                        _vm.$set(item, "poFirst", $$v)
                                      },
                                      expression: "item.poFirst",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "AccountManagement.dashboard.POFirst"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    attrs: {
                                      disabled: "",
                                      "true-label": 1,
                                      "false-label": 0,
                                    },
                                    model: {
                                      value: item.poArrived,
                                      callback: function ($$v) {
                                        _vm.$set(item, "poArrived", $$v)
                                      },
                                      expression: "item.poArrived",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "AccountManagement.dashboard.POArrived"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    attrs: {
                                      disabled: "",
                                      "true-label": 1,
                                      "false-label": 0,
                                    },
                                    model: {
                                      value: item.poReceived,
                                      callback: function ($$v) {
                                        _vm.$set(item, "poReceived", $$v)
                                      },
                                      expression: "item.poReceived",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "AccountManagement.dashboard.POReceived"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c("div", {
                              staticStyle: { width: "100%", height: "20px" },
                            }),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              width: "22%",
                              height: "180px",
                              border: "2px solid #EBEEF5",
                              padding: "10px 20px",
                              display: "flex",
                              "justify-content": "space-around",
                              "flex-direction": "column",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { "font-size": "larger" } },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("AccountManagement.dashboard.Orderi")
                                  )
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    attrs: {
                                      disabled: "",
                                      "true-label": 1,
                                      "false-label": 0,
                                    },
                                    model: {
                                      value: item.orderFirst,
                                      callback: function ($$v) {
                                        _vm.$set(item, "orderFirst", $$v)
                                      },
                                      expression: "item.orderFirst",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "AccountManagement.dashboard.OrderFirst"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    attrs: {
                                      disabled: "",
                                      "true-label": 1,
                                      "false-label": 0,
                                    },
                                    model: {
                                      value: item.orderDispatched,
                                      callback: function ($$v) {
                                        _vm.$set(item, "orderDispatched", $$v)
                                      },
                                      expression: "item.orderDispatched",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "AccountManagement.dashboard.OrderDispatched"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c("div", {
                              staticStyle: { width: "100%", height: "20px" },
                            }),
                            _c("div", {
                              staticStyle: { width: "100%", height: "20px" },
                            }),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }